export default {
  path: '/lvy-match-maker',
  component: () => import('./Index'),
  meta: {
    title: '红娘服务',
    designWidth: 750
  }
}
